module.exports = __webpack_public_path__ + "static/steamboat-gothic-1fe3903aee57bdf52d59294c18c654f9.jpg";